import { useActivateCmpMemberMutation, useSuspendCmpMemberMutation } from "../../../graphql/types";
import { MemberStatusUpdate, updateMemberSuspension } from "./memberStatus";

export const useMemberStatusUpdate = () => {
  const options = { refetchQueries: ["getChamberMember", "getAllChamberMembers"] };
  const [activateMember, { loading: activating }] = useActivateCmpMemberMutation(options);
  const [suspendMember, { loading: suspending }] = useSuspendCmpMemberMutation(options);

  return {
    loading: activating || suspending,
    updateMemberStatus: (input: MemberStatusUpdate) => updateMemberSuspension({
      ...input,
      activateMember: async (actionInput) => {
        const result = await activateMember({ variables: { input: actionInput } });
        return result.data?.activateCmpMember;
      },
      suspendMember: async (actionInput) => {
        const result = await suspendMember({ variables: { input: actionInput } });
        return result.data?.suspendCmpMember;
      },
    }),
  };
};
